import { WSQueryConfig } from "@ws-react-query";
import { getWorkItem } from "../../../services/workItem";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";

export const QUERY_WORK_ITEM = "QUERY_WORK_ITEM";

export const useQueryWorkItem = (
  workItemId: string,
  config?: WSQueryConfig<
    Awaited<ReturnType<typeof getWorkItem>>,
    WSServiceError
  >
) =>
  useWSQuery(
    [QUERY_WORK_ITEM, workItemId],
    () => getWorkItem(workItemId),
    config
  );
